import { aboutRoutePaths } from './paths';

import type { RouteObject } from 'react-router-dom';

export const aboutRoute: RouteObject = {
  path: aboutRoutePaths.about.path,
  async lazy() {
    const AboutPage = await import('@/pages/about/AboutPage');
    return { Component: AboutPage.default };
  },
};
